import React from 'react';

import { Breadcrumb, Row, Col, Menu, Button, Dropdown, DatePicker, List } from 'antd';
import { Line } from '@ant-design/plots';
import {
  queryDeviceUsageByMonth, companyDeviceTrend
} from "./gqls";
import Client from '../../../../../lib/gqlClient';
import getWantTimestamp from '../../../../../lib/utils/times'
import moment from 'moment-timezone';
import { useState } from 'react';

 const AppUsage = () => {
  const [appId,setAppId]=useState([])
  const [isSelectDeviceOrMeasure,setIsSelectDeviceOrMeasure]=useState(true)//true app  false  companies
  const [deviceOrMeasureSelectItem,setDeviceOrMeasureSelectItem]=useState(3)//默认显示全年 1本月 2本季度 3全年
  const [listData,setListData]=useState([])
  const [selectTypeList,setSelectTypeList]=useState([])//当前展示list
  const [selectType,setSelectType]=useState('')//当前选择类型
  const [deviceUsageByMonth,setDeviceUsageByMonth]=useState([])

  React.useEffect(() => {
    const id=sessionStorage.getItem("companyId")
    setAppId(id)
    console.log(appId)
    isGetSelectDeviceOrMeasure(deviceOrMeasureSelectItem)
    let year = moment().utc().year();
    let month = moment().utc().month() + 1;
    getDeviceUsageByMonth(year, month)
  },[])

  function onClick(e){
    console.log(e.key)
    if(e.key==="1"){
      setIsSelectDeviceOrMeasure(true)
    }else{
      setIsSelectDeviceOrMeasure(false)
    }
    isGetSelectDeviceOrMeasure(deviceOrMeasureSelectItem)
  }
  function onSelectType(e){
    console.log(e.label)
    setSelectType(e.label)
    isGetSelectDeviceOrMeasure(deviceOrMeasureSelectItem)
  }
  function isGetSelectDeviceOrMeasure(type) {

    setDeviceOrMeasureSelectItem(type)
    var months = []
    switch (type) {
      case 1:
        months = getWantTimestamp("thisYearDayZero");
        break;
      case 2:
        months = getWantTimestamp("threeMonthDayZeroList");
        break;
      case 3:
        let month = moment().utc().month() + 1;
        let list = []
        for (let index = 0; index < month; index++) {
          list[index] = index + 1
        }
        months = list;
        break;
      default: {
        console.log("类型错误");
        return months = [];
      }
    }
    let year = moment().utc().year();
    console.log(isSelectDeviceOrMeasure, type, months, year)
    getCompanyDeviceTrend(type, months, year)
  }
  function getCompanyDeviceTrend(type, months, year) {
    Client(
      companyDeviceTrend,
      {
        company: "5be936314e36453aeab30281",
        year: year,
        months: months,
      }
    ).then((res) => {
      console.log(res)
      if (res !== null) {
        let data = [{}];
        const list = res.data.companyDeviceTrend
        console.log(list)
        list.map((item, index) => {
          data[index] = {
            Date: item.year + "-" + item.month,
            scales: isSelectDeviceOrMeasure ? item.deviceCount : item.measureCount,
          }
        })
      setListData(data)
        
      }
    }).catch(e => {
      // console.log(e);
    })
  }
//切换月份数据
  function onChange(date, dateString) {
    let year = date.utc().year();
    let month = date.utc().month() + 1;
    console.log(year,month);
    getDeviceUsageByMonth(year, month)
  }
 
  function getDeviceUsageByMonth(year, months) {
    Client(
      queryDeviceUsageByMonth,
      {
        company: "5be936314e36453aeab30281",
        year: year,
        months: months,
      }
    ).then((res) => {
      console.log(res)
      if (res !== null) {
        const list = res.data.getDeviceUsageByMonth
        console.log(list)
        setDeviceUsageByMonth(list)
      }
    }).catch(e => {
      // console.log(e);
    })
  }

  
  return (
    <div style={{ height: '100%', width: '100%', }}>

      {/* 标题头 */}
      <div style={{ height: '503px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
        <Breadcrumb style={{ marginLeft: '20px', marginTop: "6px" }}>
          <Breadcrumb.Item><a href="" style={{ fontSize: '12px' }}>首页</a></Breadcrumb.Item>
          <Breadcrumb.Item><a href="" style={{ fontSize: '12px' }}>SDK Dashboard</a></Breadcrumb.Item>
          <Breadcrumb.Item><a href="" style={{ fontSize: '12px' }}>公司列表</a></Breadcrumb.Item>
          <Breadcrumb.Item><a href="" style={{ fontSize: '12px' }}>App Usage</a></Breadcrumb.Item>
        </Breadcrumb>

        <li style={{ textAlign: 'center', marginTop: '8px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #000' }}>App使用趋势</li>

        <div style={{ height: '404px', padding: '0px', marginTop: '40px' }}>
          <div style={{ height: '55px', padding: '0px', }}>
            <Row>
              <Col span={12}>
                <Menu defaultSelectedKeys={['1']}
                  mode="horizontal"
                  style={{ justifyContent: 'start' }}
                  items={items}
                  onClick={onClick}>
                </Menu>
              </Col>
              <Col span={12} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                <Dropdown overlay={<Menu onClick={onSelectType} items={selectTypeList} />} placement="bottomLeft" onClick={onSelectType}>
                  <Button onClick={onSelectType}>
                    Select device type
                  </Button>
                </Dropdown>
                <Button className="btn" onClick={() => isGetSelectDeviceOrMeasure(2)} type="text" style={{ border: 'none' }}>本季度</Button>
                <Button className="btn" onClick={() => isGetSelectDeviceOrMeasure(3)} type="text" style={{ border: 'none', marginRight: '18px' }}>本年</Button>
              </Col>
            </Row>
            <div style={{ height: '1px', backgroundColor: '#E8E8E8' }} />
          </div>
          <a style={{ marginLeft: '56px', marginTop: '24px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #2657F9' }}>总使用设备数趋势</a>
          <Line{...{
            data:listData,
            padding: 'auto',
            xField: 'Date',
            yField: 'scales',
            xAxis: {
              tickCount: 5,
            },
            smooth: true,
            lineStyle: { r: 1, stroke: "#1890FF", strokeOpacity: 1, fill: "#2657F9", fillOpacity: 0.3, },

          }} style={{ height: '246px', marginTop: '20px', marginBottom: '33px', marginLeft: '99px', marginRight: '94px' }} />
        </div>
      </div>


      <div style={{ height: '460px', padding: '0px', backgroundColor: 'white', borderRadius: '2px', marginTop: '15px' }}>
        <li style={{ textAlign: 'center', paddingTop: '30px', paddingBottom: '40px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #000', }}>月使用详情</li>
        <div style={{ height: '55px', padding: '0px', }}>

          <Row>
            <Col span={12}>
              <li style={{ marginLeft: '32px', marginTop: '8px', display: 'block', fontSize: '14px', lineHeight: '24px', color: ' #000' }}>App Name</li>

            </Col>
            <Col span={12} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
              <DatePicker showToday={true}onPanelChange={onChange} picker="month" style={{ marginRight: '32px', }} />
            </Col>
          </Row>

          <Row style={Styles.listTitleBg}>
            <Col span={8} style={Styles.listTitleText}>
              Device Model
            </Col>
            <Col span={8} style={Styles.listTitleText}>
              Device in Use in this Month
            </Col>
            <Col span={8} style={Styles.listTitleText}>
              Measurement in this Month
            </Col>
          </Row>

          <List
            style={{ marginLeft: '32px', marginRight: '32px' }}
            itemLayout="vertical"
            split="true"
            dataSource={deviceUsageByMonth}
            renderItem={(item) => (
              <List.Item style={Styles.item}>
                <Row >
                  <Col span={8} style={Styles.listTitleText}>
                    {item.deviceModel}
                  </Col>
                  <Col span={8} style={Styles.listTitleText}>
                    {item.activeCount}
                  </Col>
                  <Col span={8} style={Styles.listTitleText}>
                    {item.measureCount}
                  </Col>

                </Row>
              </List.Item>
            )}
          />
        </div>

      </div>


    </div>
  );
}

function getItem(label, key,) {
  return {
    key,
    label,
  };
}
const items = [
  getItem('总使用设备书', '1'),
  getItem('总测量数据', '2'),

];
const Styles = {
  listTitleBg: {
    height: '54px',
    padding: '0px',
    backgroundColor: '#F3F3F3',
    borderRadius: '2px',
    marginTop: '30px',
    marginLeft: '32px',
    marginRight: '32px'
  },
  listTitleText: {
    fontSize: '14px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '100px'
  },
  item: {
    height: '54px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%, 100%',
  },
}
export default AppUsage